/** Custom events for app-wide keyboard shortcuts */
export const APP_SHORTCUT_NEW_SERVICE_CALL = 'repairlab:shortcut-new-service-call';
export const APP_SHORTCUT_SAVE_SERVICE_CALL = 'repairlab:shortcut-save-service-call';

export type AppShortcutDef = {
  /** Physical key labels shown as keyboard button chips, e.g. ['Alt', 'S'] */
  keys: string[];
  action: string;
};

/** Shown in the header help dialog */
export const APP_KEYBOARD_SHORTCUTS: AppShortcutDef[] = [
  { keys: ['Alt', 'S'], action: 'כרטיסיית קריאות השירות' },
  { keys: ['Alt', 'D'], action: 'דשבורד' },
  { keys: ['Alt', 'N'], action: 'קריאה חדשה' },
  { keys: ['Ctrl', 'S'], action: 'שמירת קריאה (כשהטופס פתוח)' },
  { keys: ['Esc'], action: 'סגירת חלון / דיאלוג' },
];

const EDIT_ONLY_SHORTCUT_ACTIONS = new Set([
  'קריאה חדשה',
  'שמירת קריאה (כשהטופס פתוח)',
]);

/** Filter shortcuts help list by edit permission (external viewers see nav-only). */
export function getVisibleKeyboardShortcuts(canEditServiceCalls: boolean): AppShortcutDef[] {
  if (canEditServiceCalls) return APP_KEYBOARD_SHORTCUTS;
  return APP_KEYBOARD_SHORTCUTS.filter((item) => !EDIT_ONLY_SHORTCUT_ACTIONS.has(item.action));
}

export function dispatchAppShortcut(eventName: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(eventName));
}
